import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { normalizeIncomingCallRecord, } from '../model/qstat-calls.model';
import { appendCriteriaContains, appendCriteriaEquals, appendCriteriaIn, readPagedRows, } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiBase = API_ROUTES.qstat.incomingCalls;
const initialState = {
    loading: false,
    errorMessage: null,
    records: [],
    totalItems: 0,
};
function buildParams(params) {
    const q = new URLSearchParams();
    appendCriteriaEquals(q, 'startDate', params.startDate);
    appendCriteriaEquals(q, 'endDate', params.endDate);
    appendCriteriaIn(q, 'agent', params.agents);
    appendCriteriaIn(q, 'queues', params.queues);
    appendCriteriaContains(q, 'phoneNumber', params.phoneNumber);
    appendCriteriaEquals(q, 'event', params.event);
    appendCriteriaEquals(q, 'callType', params.callType);
    appendCriteriaEquals(q, 'trunkNames', params.trunkName);
    q.set('sort', params.sort ?? 'id,desc');
    return q;
}
export const getIncomingCallsReport = createAsyncThunk('incomingCalls/fetch_report', async (params) => {
    const q = buildParams(params);
    const qs = q.toString();
    const url = qs ? `${apiBase}?${qs}` : apiBase;
    const res = await axios.get(url);
    const { rows, total } = readPagedRows(res.data, res.headers);
    return { rows: rows.map(normalizeIncomingCallRecord), total };
}, { serializeError: serializeAxiosError });
export const incomingCallsSlice = createSlice({
    name: 'incomingCalls',
    initialState: initialState,
    reducers: {
        clearIncomingCallsReport(state) {
            state.records = [];
            state.totalItems = 0;
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getIncomingCallsReport.fulfilled, (state, action) => {
            state.loading = false;
            state.records = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getIncomingCallsReport), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getIncomingCallsReport), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearIncomingCallsReport } = incomingCallsSlice.actions;
export default incomingCallsSlice.reducer;
